<template>
    <el-select
            v-bind="$attrs"
            :value="value"
            @change="change"
            filterable
            clearable
            remote
            :remote-method="search"
            :loading="loading"
            :disabled="!available"
    >
        <el-option
                v-for="item in options"
                :key="item.id"
                :label="format(item)"
                :value="item.id">
        </el-option>
    </el-select>
</template>

<script>
  export default {
    props: {
      url: String,
      value: null,
      brandId: null,
      model: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        loading: false,
        options: [],
      };
    },

    computed: {
      /**
       * @return {object|null}
       */
      current() {
        return _.find(this.options, {id: this.value}) || null;
      },

      /**
       * @return {boolean}
       */
      available() {
        return !this.disabled && Boolean(this.brandId);
      },
    },

    watch: {
      brandId(val) {
        if (!val) {
          this.options = [];
          this.change(null);
          return;
        }

        if (val !== _.get(this.current, 'brand_id')) {
          this.change(null);
        }

        this.search('');
      },
    },

    methods: {
      /**
       * @param {string} text
       */
      search(text) {
        this.loading = true;
        axios.get(this.url, {params: this.getQueryParams(text)})
          .then(this.onSuccess)
          .catch(this.onError)
          .finally(() => {
            this.loading = false;
          })
      },

      /**
       * @param {string} search
       * @return {object}
       */
      getQueryParams(search) {
        return _.pickBy({search, brand_id: this.brandId});
      },

      /**
       * @property {object} data
       */
      onSuccess({data}) {
        this.options = _.get(data, 'data');
      },

      /**
       * @property {object} response
       */
      onError({response}) {
        this.options = [];
      },

      /**
       * @param {number|null} value
       * @emits input
       */
      change(value) {
        this.$emit('input', value);
      },
    },
  }
</script>
